export default function t(){return{validate(t){return{valid:true}}}}